import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { selectData } from "../../../services/store/userSlice";
import { LeaveStatusCode } from "../../../common/util/constants";
import { Image } from "primereact/image";
import properties from "../../../config/environmentProperties";
import ViewField from "../components/ViewField";
import { TabView, TabPanel } from "primereact/tabview";
import { utitService } from "../../../services/util";
import { Dialog } from "primereact/dialog";
import { Chip } from "primereact/chip";
import { ContextMenu } from "primereact/contextmenu";

export const ViewLeave = ({
  leave,
  visible = false,
  onHide,
  style,
  header = "Leave Details",
  tabIndex = 0,
}) => {
  // const { userAbsenceCodes, absenceCode, leaveCode } = useSelector(selectData);
  const selData = useSelector(selectData);
  const { user } = useSelector((state) => state.user);
  const { currentEnvironment } = properties;
  const [files, setFiles] = useState([]);
  const [sel, setSel] = useState(null);
  const [absenceCode, setAbsenceCode] = useState(null);
  const [leaveCode, setLeaveCode] = useState(null);
  const [frameHeight, setFrameHeight] = useState("400px");
  const [index, setIndex] = useState(tabIndex);
  const [region, setRigion] = useState("ESIN");
  useEffect(() => {
    setSel(null);
    console.log("On load");
  }, []);

  useEffect(() => {
    if (user) {
      const leCode = user?.LegalEntity?.code || "ESIN";
      setRigion(leCode);
      console.log("On user change");
    }
  }, [user]);

  useEffect(() => {
    if (selData) {
      setSel(null);
      setAbsenceCode(selData.localAbsenceCodes);
      setLeaveCode(selData.leaveCode);
      console.log("On sel data change");
    }
  }, [selData]);

  useEffect(() => {
    setIndex(tabIndex);
    setSel(null);
    console.log("On index change");
  }, [tabIndex]);

  const cm = useRef(null);
  const items = [
    {
      label: "Download",
      icon: "pi pi-download",
      command: () => open(sel, "download"),
    },
    {
      label: "Open in new tab",
      icon: "pi pi-eye",
      command: () => open(sel, "view"),
    },
  ];
  useEffect(() => {
    if (leave) {
      console.log("On leve change");
      const filesArr = leave?.attachment?.split(",") || [];
      const fileObjArr = filesArr.map((f) => {
        const arr = f.split(".");
        const extension = arr[arr.length - 1];
        let icon = "pi-image";
        if (["jpg", "png"].includes(extension)) {
          icon = "pi-image";
        } else if (["pdf"].includes(extension)) {
          icon = "pi-file-pdf";
        } else {
          icon = "pi-file";
        }
        return { name: f, ext: extension, icon: icon };
      });
      setSel(null);
      setFiles(fileObjArr);
    }
  }, [leave]);

  const open = (file, action) => {
    const selectedFile = `${currentEnvironment["docPath"]}leave-documents/${file.name}`;
    if (action === "download") {
      fetch(selectedFile)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = file.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    } else {
      window.open(selectedFile, "_blank");
    }
  };

  const renderDetails = (
    <div className="detail-view mt-1 " style={{ height: "auto" }}>
      <TabView activeIndex={index} onTabChange={(e) => setIndex(e.index)}>
        <TabPanel header={"Details"}>
          <div className="mt-3">
            <div className="grid">
              <ViewField
                className="col-6"
                label="Start Date"
                value={utitService.dateParser(
                  leave?.startDate,
                  "MMM DD, YYYY ( dddd )",
                )}
              />
              <ViewField
                className="col-6"
                label="End Date"
                value={utitService.dateParser(
                  leave?.endDate,
                  "MMM DD, YYYY ( dddd )",
                )}
              />
            </div>
            <div className="grid">
              <ViewField
                className="col-6"
                label="Absence Code"
                body={() => (
                  <>
                    <strong className="mr-2">{leave?.absenceCode}</strong>(
                    {leave?.LeaveAbsenceCode?.title})
                  </>
                )}
              />
              <ViewField
                className="col-6"
                label="Status"
                body={() => (
                  <>
                    <span className={`type-${leave?.status}`}>
                      {LeaveStatusCode[leave?.status]}
                    </span>
                  </>
                )}
              />
            </div>
            <div className="grid">
              <ViewField
                className="col-6"
                label="Duration"
                body={() => (
                  <>
                    <strong className="mr-2">{leave?.leaveType}</strong>(
                    {leaveCode[leave?.leaveType]?.title})
                  </>
                )}
              />
            </div>
            {region === "ESAU" && leave?.leaveHours && (
              <div className="grid">
                <ViewField
                  className="col-6"
                  label="Leave Hours"
                  value={leave?.leaveHours}
                />
              </div>
            )}

            <div className="grid pr-0">
              <ViewField
                className="col-12 pr-0"
                labelClassName="col-2"
                valueClassName="col-10 pl-1 pr-0"
                label="Reason of Leave"
                value={leave?.reasonOfLeave}
              />
            </div>
            <div className="grid pr-0">
              {[2, 3].includes(leave?.status) && (
                <>
                  <ViewField
                    className="col-12 pr-0"
                    labelClassName="col-2"
                    valueClassName="col-10 pl-1  pr-0"
                    label={
                      leave?.status === 2
                        ? "Approver message"
                        : "Rejection note"
                    }
                    value={leave?.reason}
                  />
                </>
              )}
            </div>
            {leave?.recallReason !== "" && (
              <div className="grid pr-0">
                <ViewField
                  className="col-12 pr-0"
                  labelClassName="col-2"
                  valueClassName="col-10 pl-1 pr-0"
                  label="Recall Reason"
                  value={leave?.recallReason}
                />
              </div>
            )}
            {["ML", "PL"].includes(leave?.absenceCode) && (
              <>
                {["ESIN"].includes(region) && (
                  <div className="grid">
                    <ViewField
                      className="col-6"
                      label="Expected Delivery Date"
                      value={utitService.dateParser(
                        leave?.expectedDeliveryDate,
                        "MMM DD, YYYY ( dddd )",
                      )}
                    />
                    <ViewField
                      className="col-6"
                      label="Number of Child"
                      value={leave?.numberOfChild}
                    />
                  </div>
                )}
                {leave?.isChildAdopted === true && (
                  <>
                    <div className="grid">
                      <ViewField
                        className="col-6"
                        label="Adoption Date"
                        value={utitService.dateParser(
                          leave?.adoptionDate,
                          "MMM DD, YYYY ( dddd )",
                        )}
                      />
                      <ViewField
                        className="col-6"
                        label="Adopted Child Age"
                        value={leave?.adoptedChildAge + " Month(s)"}
                      />
                    </div>
                    <div className='grid pr-0'>
                        <ViewField className='col-12 pr-0' labelClassName='col-4 md:col-2' valueClassName='col-8 md:col-10 pl-1 pr-0' label='Reason of Leave' value={leave?.reasonOfLeave} />
                    </div>
                    <div className='grid pr-0'>
                        {[2, 3].includes(leave?.status) && <>
                            <ViewField className='col-12 pr-0' labelClassName='col-4 md:col-2' valueClassName='col-8 md:col-10 pl-1  pr-0' label={leave?.status === 2 ? 'Approver message' : 'Rejection note'} value={leave?.reason} />
                        </>}
                    </div>
                    {leave?.recallReason !== '' && <div className='grid pr-0'>
                        <ViewField className='col-12 pr-0' labelClassName='col-4 md:col-2' valueClassName='col-8 md:col-10 pl-1 pr-0' label='Recall Reason' value={leave?.recallReason} />
                    </div>}
                    {['ML', 'PL'].includes(leave?.absenceCode) && <>
                        {['ESIN'].includes(region) && <div className='grid'>
                            <ViewField className='col-6' label='Expected Delivery Date' value={utitService.dateParser(leave?.expectedDeliveryDate, 'MMM DD, YYYY ( dddd )')} />
                            <ViewField className='col-6' label='Number of Child' value={leave?.numberOfChild} />
                        </div>}
                        {leave?.isChildAdopted === true && <>
                            <div className='grid'>
                                <ViewField className='col-6' label='Adoption Date' value={utitService.dateParser(leave?.adoptionDate, 'MMM DD, YYYY ( dddd )')} />
                                <ViewField className='col-6' label='Adopted Child Age' value={leave?.adoptedChildAge + ' Month(s)'} />
                            </div>
                        </>}
                        {leave?.isMiscarriage === true && <>
                            <div className='grid'>
                                <ViewField className='col-6' label='Miscarriage Date' value={utitService.dateParser(leave?.miscarriageDate, 'MMM DD, YYYY ( dddd )')} />
                                <ViewField className='col-6' label='Is Illness' value={leave?.isIllness ? 'Yes' : 'No'} />
                            </div>
                        </>}
                    </>}
                    {leave?.absenceCode === 'BL' && <>
                        <div className='grid'>
                            <ViewField className='col-6' label='Expiration Date' value={utitService.dateParser(leave?.expirationDate, 'MMM DD, YYYY ( dddd )')} />
                            {/* <ViewField className='col-6' label='Is Illness' value={leave?.isIllness ? 'Yes' : 'No'} /> */}
                        </div>
                    </>}
                  </>
                )}
                {leave?.isMiscarriage === true && (
                  <>
                    <div className="grid">
                      <ViewField
                        className="col-6"
                        label="Miscarriage Date"
                        value={utitService.dateParser(
                          leave?.miscarriageDate,
                          "MMM DD, YYYY ( dddd )",
                        )}
                      />
                      <ViewField
                        className="col-6"
                        label="Is Illness"
                        value={leave?.isIllness ? "Yes" : "No"}
                      />
                    </div>
                  </>
                )}
              </>
            )}
            {leave?.absenceCode === "BL" && (
              <>
                <div className="grid">
                  <ViewField
                    className="col-6"
                    label="Expiration Date"
                    value={utitService.dateParser(
                      leave?.expirationDate,
                      "MMM DD, YYYY ( dddd )",
                    )}
                  />
                  {/* <ViewField className='col-6' label='Is Illness' value={leave?.isIllness ? 'Yes' : 'No'} /> */}
                </div>
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel header={"Attachments"}>
          <div className="grid">
            <div className="col-12">
              <span>
                <ContextMenu model={items} ref={cm}></ContextMenu>
                {files.map((file) => (
                  <span className="link" onClick={() => setSel(file)}>
                    <Chip
                      label={file.name}
                      icon={`pi ${file.icon}`}
                      className="mr-2 mb-2"
                      onContextMenu={(e) => {
                        setSel(file);
                        cm.current.show(e);
                      }}
                    />
                  </span>
                ))}
              </span>
            </div>
            <div className="col-12" style={{ height: sel ? "400px" : "auto" }}>
              {sel && sel.ext === "pdf" && (
                <iframe
                  key={`PDF-DOC-${user.id}`}
                  src={`${currentEnvironment["docPath"]}leave-documents/${sel.name}`}
                  width="100%"
                  height="100%"
                  border="0"
                  style={{ border: "0px" }}
                ></iframe>
              )}
              {sel && sel.ext !== "pdf" && (
                <Image
                  key={`IMG-DOC-${user.id}`}
                  src={`${currentEnvironment["docPath"]}leave-documents/${sel.name}`}
                  alt="Image"
                  width="100%"
                  preview
                />
              )}
              {!sel && (
                <div>
                  <h1>No file selected</h1>
                </div>
              )}
            </div>
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
  return (
    <Dialog header={header} visible={visible} onHide={onHide} style={style}>
      {renderDetails}
    </Dialog>
  );
};
